// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2ubGl","col":"styles_col__2fYJf"};